export const runbookExecutionHistoryConstants = {
  GET_REQUEST: "GET_RUNBOOK_EXECUTION_HISTORY_REQUEST",
  GET_SUCCESS: "GET_RUNBOOK_EXECUTION_HISTORY_SUCCESS",
  GET_FAILURE: "GET_RUNBOOK_EXECUTION_HISTORY_FAILURE",
};
